export default __webpack_public_path__ + "static/media/technicalSkills.fa9e239a.jfif";